<template>
  <div class="bg-pruta-green flex-1 flex flex-col gap-4 items-center justify-center p-6 rounded-xl shadow-[0px_16px_32px_0px_rgba(0,0,0,0.1),0px_8px_16px_0px_rgba(0,0,0,0.1),0px_4px_8px_0px_rgba(0,0,0,0.1),0px_2px_4px_0px_rgba(0,0,0,0.1)] relative">
    <!-- Step Number -->
    <p class="absolute top-1 left-3 text-white/50 text-display-lg font-bold ">
      {{ stepNumber }}
    </p>

    <!-- Animation -->
    <ClientOnly>
      <Vue3Lottie
        :animationData="animationData"
        :height="96"
        :width="96"
        :loop="true"
        :autoPlay="true"
      />
    </ClientOnly>

    <!-- Content -->
    <div class="flex flex-col gap-2 w-full">
      <p class="font-bold text-xl text-brand leading-[30px]">
        {{ title }}
      </p>
      <p class="text-white text-sm font-medium leading-6">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { Vue3Lottie } from "vue3-lottie";

defineProps({
  stepNumber: {
    type: [String, Number],
    required: true
  },
  animationData: {
    type: Object,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  }
})
</script>
